// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bYB4u","title":"styles_title__1Tmo3"};